import {
  Box,
  Card,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector } from 'react-redux';
import LoadingComponent from 'src/app/components/Loading';
import { Pagination } from '@material-ui/lab';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import { useState } from 'react';
import { useTheme, useMediaQuery } from '@material-ui/core';

const StatisticServiceTable = ({
  listService,
  params,
  setParams,
  totalService,
  getStatisticServicesRef
}) => {
  const isLoading = useSelector(state => state.statisticSlice.isLoading);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const limit = isMobile ? 4 : PAGE_SIZE_LIST;
  const classes = useStyles();
  const formatCurrency = (amount, locale = 'vi-VN', currency = 'VND') => {
    return amount?.toLocaleString(locale, {
      style: 'currency',
      currency: currency
    });
  };

  const handlePageChange = (event, newPage) => {
    if (!getStatisticServicesRef) return;
    const newparams = Object.assign({}, params, { page: newPage });
    setParams(newparams);
    getStatisticServicesRef(newparams);
  };

  return (
    <>
      <Card className={classes.root}>
          <div>
            <PerfectScrollbar>
              {listService && listService.length ? (
                <Box style={{ overflowX: 'auto' }} minWidth={1050}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Ngày thanh toán</TableCell>
                        <TableCell>Mã thiết bị</TableCell>
                        <TableCell>Serial</TableCell>
                        <TableCell>Phiên bản</TableCell>
                        <TableCell>Tên/Biển số</TableCell>
                        <TableCell>Tên gói dịch vụ</TableCell>
                        <TableCell>Hạn gói</TableCell>
                        <TableCell>Số tiền</TableCell>
                        <TableCell>Người dùng</TableCell>
                        <TableCell>Số điện thoại</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {listService.map((data, index) => (
                        <TableRow hover key={data?.id}>
                          <TableCell>
                            {data?.created_at
                              ? moment(data?.deviceServicePackages[0]?.created_at).format('HH:mm:ss DD-MM-yyyy')
                              : '-'}
                          </TableCell>
                          <TableCell>
                            {data?.deviceType?.name || '--'}
                          </TableCell>
                          <TableCell>{data?.serial || '--'}</TableCell>
                          <TableCell>
                            {data?.hardware_version || '--'}
                          </TableCell>
                          <TableCell>{data?.vehicle?.license_plate || '--'}</TableCell>
                          <TableCell>{data?.deviceServicePackages[0]?.servicePackage?.name || '--'}</TableCell>
                          <TableCell>
                            {`${data?.deviceServicePackages[0]?.servicePackage?.day_limit} Ngày` || '--'} 
                          </TableCell>
                          <TableCell>
                            {formatCurrency(data?.deviceServicePackages[0]?.servicePackage?.cost) || '--'}
                          </TableCell>
                          <TableCell>
                            {data?.end_user?.user?.full_name || '--'}
                          </TableCell>
                          <TableCell>
                            {data?.end_user?.user?.phone || '--'}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              ) : (
                <div className="text-center pb-5">
                  <img
                    src="/static/empty.png"
                    className="justify-content-center"
                  />
                  <h4> Danh sách trống </h4>
                </div>
              )}
            </PerfectScrollbar>
          </div>
      </Card>
      {listService && listService?.length > 0 && (
        <div class="mt-3 mr-4 float-right">
          <Box style={{display:'flex', justifyContent:'center', alignItems:'center', gap:'15px'}}>
            <Typography style={{ fontSize:'14px'}}>Tổng: {totalService}</Typography>
          <Pagination
                        count={Math.ceil(totalService / limit)}
                        color="primary"
                        size="small"
                        onChange={handlePageChange}
                        page={Number(params.page) || 1}
                        siblingCount={isMobile ? 0 : 1}
                        boundaryCount={isMobile ? 1 : 2}
                        showFirstButton={!isMobile}
                        showLastButton={!isMobile}
                      />
          </Box>
        </div>
      )}
    </>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    '&.MuiPaper-elevation1': {
      boxShadow: 'none'
    }
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  groupAction: {
    display: 'flex',
    alignItems: 'center',
    '& .action': {
      cursor: 'pointer',
      padding: '0 5px',
      '&:hover': {
        color: '#3f51b5'
      }
    }
  },
  minWithColumn: {
    minWidth: '150px'
  }
}));

export default StatisticServiceTable;
